interface TopItem {
  domain: string;
  clicks: number;
}

export default function TopDomains({ items }: { items: TopItem[] }) {
  const max = Math.max(...items.map((item) => item.clicks), 1);
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950">域名点击排行</h3>
        <p className="mt-1 text-xs text-foreground-500">按累计点击量排序</p>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-foreground-500">还没有域名数据。</p>
      ) : (
        <div className="flex flex-col gap-4">
        {items.map((item, index) => (
          <div key={item.domain}>
            <div className="mb-1.5 flex items-center justify-between gap-3 text-sm">
              <span className="flex items-center gap-2 text-foreground-800">
                <span className="flex h-5 w-5 items-center justify-center rounded bg-background-100 text-[10px] font-semibold text-foreground-600">
                  {index + 1}
                </span>
                <span className="truncate">{item.domain}</span>
              </span>
              <span className="font-medium text-foreground-950">{item.clicks.toLocaleString()}</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-100">
              <div
                className={`h-full rounded-full ${index === 0 ? "bg-primary-500" : "bg-accent-500"}`}
                style={{ width: `${Math.round((item.clicks / max) * 100)}%` }}
              />
            </div>
          </div>
        ))}
        </div>
      )}
    </div>
  );
}